import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home as HomeIcon, ArrowLeft } from 'lucide-react';
import { updatePageSEO } from '../utils/seo';

const NotFound = () => {
  const location = useLocation();
  const isBlogUrl = location.pathname.startsWith('/blog');

  useEffect(() => {
    // Update SEO for 404 page with noindex
    updatePageSEO({
      path: '/404',
      title: '404 - Page Not Found | Morning Sunday Teer',
      description: 'The page you are looking for does not exist.'
    });
    
    // Add noindex meta tag for 404 pages
    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    metaRobots.setAttribute('content', 'noindex, nofollow');
    
    // Cleanup: remove noindex when leaving 404 page
    return () => {
      const robots = document.querySelector('meta[name="robots"]');
      if (robots) {
        robots.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-coral-600">404</h1>
        </div>
        
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Page Not Found
        </h2>
        
        {isBlogUrl ? (
          <div className="mb-8">
            <p className="text-lg text-gray-600 mb-4">
              This blog page has been permanently removed.
            </p>
            <p className="text-sm text-gray-500">
              We no longer maintain blog posts. Please visit our homepage for the latest Morning Sunday Teer results.
            </p>
          </div>
        ) : (
          <p className="text-lg text-gray-600 mb-8">
            Sorry, the page you are looking for does not exist or has been moved.
          </p>
        )}
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 bg-coral-600 text-white font-semibold rounded-lg hover:bg-coral-700 transition-colors"
          >
            <HomeIcon className="w-5 h-5 mr-2" />
            Go to Homepage
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center px-6 py-3 bg-gray-200 text-gray-900 font-semibold rounded-lg hover:bg-gray-300 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Go Back
          </button>
        </div>
        
        <div className="mt-12 p-6 bg-blue-50 rounded-lg border-l-4 border-blue-500">
          <h3 className="font-semibold text-gray-900 mb-2">
            Looking for Teer Results?
          </h3>
          <p className="text-gray-700 text-sm">
            Visit our homepage for today's Morning Sunday Teer results, common numbers, and previous results.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
